/**
 * MUTAGIM.SHOP — Chat Support Widget (Phase 19)
 * Intégration Crisp ou Intercom configurable
 */

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function ChatSupportWidget() {
  const { i18n } = useTranslation();
  const [config, setConfig] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      const res = await fetch(`${API_URL}/api/settings/public`);
      if (res.ok) {
        const data = await res.json();
        setConfig({
          crisp_id: data.crisp_website_id,
          intercom_id: data.intercom_app_id
        });
      }
    } catch (error) {
      console.error('Failed to load chat config:', error);
    }
  };

  useEffect(() => {
    if (!config || loaded) return;
    
    // Ne pas charger sur les pages admin
    if (window.location.pathname.startsWith('/admin')) return;

    const isRTL = i18n.dir() === 'rtl';

    // Crisp
    if (config.crisp_id) {
      loadCrisp(config.crisp_id, isRTL);
      setLoaded(true);
    }
    // Intercom
    else if (config.intercom_id) {
      loadIntercom(config.intercom_id);
      setLoaded(true);
    }
  }, [config, loaded, i18n]);

  return null; // Widget is injected via script
}

function loadCrisp(websiteId, isRTL) {
  window.$crisp = [];
  window.CRISP_WEBSITE_ID = websiteId;
  
  // Configuration RTL
  if (isRTL) {
    window.$crisp.push(['config', 'position:reverse', true]);
  }
  
  // Theme color
  window.$crisp.push(['config', 'color:theme', '#C0000C']);
  
  // Load script
  const script = document.createElement('script');
  script.src = 'https://client.crisp.chat/l.js';
  script.async = true;
  document.head.appendChild(script);
  
  console.log('Crisp chat loaded');
}

function loadIntercom(appId) {
  window.intercomSettings = {
    app_id: appId,
    custom_launcher_selector: '#intercom-launcher',
    hide_default_launcher: false,
    background_color: '#C0000C',
  };
  
  // Load script
  (function(){
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === "function") {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      var d = document;
      var i = function(){ i.c(arguments); };
      i.q = [];
      i.c = function(args){ i.q.push(args); };
      w.Intercom = i;
      var l = function(){
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://widget.intercom.io/widget/' + appId;
        var x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      };
      if (document.readyState === 'complete') {
        l();
      } else {
        w.addEventListener('load', l, false);
      }
    }
  })();
  
  console.log('Intercom chat loaded');
}

export default ChatSupportWidget;
